var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4144 1.75812L14.2422 0.585938C13.8516 0.195312 13.3397 0 12.8278 0C12.316 0 11.8041 0.195312 11.4138 0.585625L9.08597 2.91344L8.00003 3.99938L0.401594 11.5975L0.00471869 15.1669C-0.0452813 15.6163 0.308781 16 0.748469 16C0.776281 16 0.804406 15.9984 0.832531 15.9953L4.39941 15.6012L12.0007 8L13.0863 6.91437L15.4141 4.58656C16.1953 3.80531 16.1953 2.53906 15.4144 1.75812ZM3.71097 14.1684L1.59909 14.4016L1.83441 12.2863L9.06066 5.06L10.03 4.09062L11.9094 5.97L10.94 6.93937L3.71097 14.1684ZM14.3535 3.52562L12.9697 4.90938L11.0907 3.03L12.4744 1.64625C12.6019 1.51875 12.7507 1.49969 12.8278 1.49969C12.905 1.49969 13.0541 1.51875 13.1813 1.64625L14.3535 2.81844C14.5485 3.01375 14.5485 3.33094 14.3535 3.52562Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a335ff8cf1c938495b8d816150b279bc.svg";
export { ForwardRef as ReactComponent };